import { render } from "./postsPage.vue?vue&type=template&id=e940ed08&scoped=true"
import script from "./postsPage.vue?vue&type=script&lang=js"
export * from "./postsPage.vue?vue&type=script&lang=js"

import "./css/antd.css?vue&type=style&index=0&lang=css"
import "./postsPage.vue?vue&type=style&index=1&id=e940ed08&lang=css"
import "./postsPage.vue?vue&type=style&index=2&id=e940ed08&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e940ed08"]])

export default __exports__